export default __webpack_public_path__ + "static/media/information--end-of-motorway--g1.645f1476.png";